module.exports = __webpack_public_path__ + "img/android-download-pl.06c77e49.png";